<template>
  <el-card>
    <el-form-item>
      <el-button @click="printPreview" :loading="loading">预览</el-button>
      <el-button @click="print" :loading="loading">打印</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item>
      <div id="divPrint" class="preview-img">
        <img :src="imageBase64" :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'"
             v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>

export default {
  name: "BusPrint",

  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },

  data() {
    return {
      imageBase64: '',
      imageHeight: 320,
      imageWidth: 400,
      loading: false,
      printDto: {},
      labelName: '',
    }
  },

  created() {
    if (this.parentData.model_id === "bus_xingcai_waiguan_zhijian_record") {
      this.labelName = 'bus/print/createXingCaiLabel'
    }
    if (this.parentData.model_id === "bus_xingcai_yingdu_zhijian_record") {
      this.labelName = 'bus/print/createXingCaiLabel'
    }
    if (this.parentData.model_id === "bus_xingcai_mohou_zhijian_record") {
      this.labelName = 'bus/print/createXingCaiLabel'
    }
    if (this.parentData.model_id === "bus_chicun_zhijian_record") {
      this.labelName = 'bus/print/createXingCaiLabel'
    }
    if (this.parentData.model_id === "bus_bupin_zhijian_record") {
      this.labelName = 'bus/print/createBuPinLabel'
    }

  },

  methods: {

    async printPreview() {

      console.log(this.parentData)
      console.log(this.labelName)
      this.loading = true;
      await this.$axios.post(this.labelName, this.parentData).then(response => {
        this.loading = false;
        let res = response.data

        this.printDto = res.data;
        this.imageBase64 = res.data.imageBase64 || '';

        if (this.imageBase64.length > 0) {
          this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
        }
      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },
    async print() {
      await this.printPreview();

      if (!this.imageBase64 || this.imageBase64.length == 0) {
        return;
      }

      this.loading = true;
      // this.printDiv()
      //调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDto).then(response => {
        this.loading = false;
        let res = response.data

        console.log(res)


      }, error => {
        this.loading = false;
        console.log(`提交打印失败，${error.message}`)
        this.$message.error('连接打印机失败，请检查打印机状态。');
      })
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    }
  },
}
</script>

<style scoped>
.preview-img {
  width: 402px;
  height: 322px;
  border: solid 1px #a1a1a1;
}
</style>